import type { SVGProps } from "react";
import React from "react";

export const PlusIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  fill = "#000",
  width = 20,
  height = 20,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <path
      d="M16.6079 9.60752H10.3917V3.39209C10.3917 3.17566 10.216 3 9.99961 3C9.78317 3 9.60752 3.17566 9.60752 3.39209V9.60752H3.39209C3.17566 9.60752 3 9.78317 3 9.99961C3 10.216 3.17566 10.3917 3.39209 10.3917H9.60752V16.6079C9.60752 16.8243 9.78317 17 9.99961 17C10.216 17 10.3917 16.8243 10.3917 16.6079V10.3917H16.6079C16.8243 10.3917 17 10.216 17 9.99961C17 9.78317 16.8243 9.60752 16.6079 9.60752Z"
      fill={fill}
    />
  </svg>
);
